import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import "../../TeamManager/styles/teamManagerStyles.css";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";

import configureStore from "../../TicketingSettings/store/ticketingSettingsStore";
import TicketingSettingsContainer from "../../TicketingSettings/containers/TicketingSettingsContainer";
import AddOnPresets from "../../AddOnPresets/components/AddOnPresets";
import ManualTaxes from "../../ManualTaxes/components/ManualTaxes";
import ClassSelfTransferSettings from "./ClassSelfTransferSettings";
import GeneralLedgerDefaultSettings from "./GeneralLedgerDefaultSettings";

const SettingsTicketingDetails = ({ settingsPath, lastEditedAt, changelogVersions, addOnPresets, showActivityNames, manualTaxes, taxVenueOwnerships, classesAvailable, generalLedgerCodes, ...storeProps }) => {
  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Ticketing" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <div className="team-member-card">
        <div className="team-member-card-header">
          <div className="team-member-card-header-left">
            <div className="team-member-card-title-row">
              <h2 className="team-member-card-title">Ticketing</h2>
            </div>
            <p className="team-member-card-subtitle">
              Customize ticketing settings.
            </p>
          </div>
        </div>
        <hr style={{ margin: 0, border: 'none', borderTop: '1px solid var(--sl-border-secondary, #E9EAEB)' }} />
        <div style={{ padding: '25px 20px 0' }}>
          <Provider store={configureStore(storeProps)}>
            <TicketingSettingsContainer />
          </Provider>
        </div>
      </div>
      <AddOnPresets
        teamId={storeProps.team.id}
        currency={storeProps.team.base_currency_symbol}
        initialPresets={addOnPresets}
        showActivityNames={showActivityNames}
      />
      <ManualTaxes
        team={storeProps.team}
        initialTaxes={manualTaxes}
        venueOwnerships={taxVenueOwnerships}
      />
      {storeProps.team.can_access_general_ledger_codes && (
        <GeneralLedgerDefaultSettings
          teamId={storeProps.team.id}
          generalLedgerCodes={generalLedgerCodes}
          initialCodeIds={{
            default_general_ledger_code_id: storeProps.team.default_general_ledger_code_id,
            default_organizer_fee_general_ledger_code_id: storeProps.team.default_organizer_fee_general_ledger_code_id,
          }}
        />
      )}
      {classesAvailable && (
        <ClassSelfTransferSettings
          teamId={storeProps.team.id}
          initialEnabled={storeProps.team.class_self_transfer_enabled === true}
          initialCutoffHours={storeProps.team.class_self_transfer_cutoff_hours}
        />
      )}
    </SettingsPageWrapper>
  );
};

SettingsTicketingDetails.propTypes = {
  settingsPath: PropTypes.string.isRequired,
  lastEditedAt: PropTypes.string,
  changelogVersions: PropTypes.arrayOf(PropTypes.object),
  addOnPresets: PropTypes.arrayOf(PropTypes.object).isRequired,
  showActivityNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  manualTaxes: PropTypes.arrayOf(PropTypes.object).isRequired,
  taxVenueOwnerships: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string })).isRequired,
  classesAvailable: PropTypes.bool,
  generalLedgerCodes: PropTypes.arrayOf(PropTypes.object),
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.shape({ id: PropTypes.number.isRequired, base_currency_symbol: PropTypes.string, can_access_general_ledger_codes: PropTypes.bool, default_general_ledger_code_id: PropTypes.number, default_organizer_fee_general_ledger_code_id: PropTypes.number }).isRequired,
};

SettingsTicketingDetails.defaultProps = {
  lastEditedAt: null,
  changelogVersions: [],
  classesAvailable: false,
  generalLedgerCodes: [],
};

export default SettingsTicketingDetails;
